import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import StatusHandler from 'app/shared-components/StatusHandler'
import config from 'app/requests/ContainerNote.requests'

import {
    WithId,
} from 'app/types/common.types'
import ContainerNoteDetails from './ContainerNoteDetails'
import {
    ContainerNoteResponse,
} from './ContainerNodeDetails.types'

type Props = {
    name: string,
    rowProps: WithId<number>
}

const ContainerNoteDetailsContainer = ({
    name,
    rowProps: {
        id,
    },
}: Readonly<Props>) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useRequest<ContainerNoteResponse>({
        key: RequestKeys.getContainerNoteDetails,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(config[RequestKeys.getContainerNoteDetails]),
        enabled: Boolean(id),
    })

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <ContainerNoteDetails
                data={data}
                name={name}
            />
        </StatusHandler>
    )
}

export default ContainerNoteDetailsContainer
